module.exports = __webpack_public_path__ + "img/welcomes-preview-bag-vip.47c7d32f.png";